import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {withState} from 'shared/core';
import {FormError, ObjectSelect2} from 'shared/components';
import {Modal, ModalButtons} from 'shared/components/modals';
import CopyEmployeeShiftsModalState from 'main/containers/time_tracking/components/shifts/state/CopyEmployeeShiftsModalState';

const CopyEmployeeShiftsModal = observer(({uiState, isOpen, employee, shifts, employees, week, errors, onCopy, onClose}) => {
  const {targetEmployees} = uiState;

  return (
    <Modal
      isOpen={isOpen}
      onHide={onClose}
      size='md'
      title='time_tracking.shifts.Copy Shifts to Employees'
    >
      <div className='jumbo mb2'>
        <FormattedMessage
          id='time_tracking.shifts.COPY_EMPLOYEE_SHIFTS_DESCRIPTION'
          values={{count: shifts.length, name: employee?.name, week}}
        />
      </div>
      <ObjectSelect2
        label='time_tracking.shifts.Employees'
        multiple
        searchable
        value={targetEmployees}
        items={employees}
        onAdd={target => uiState.addTargetEmployee(target)}
        onRemove={target => uiState.removeTargetEmployee(target)}
        errorMessage={errors.toEmployees}
      />
      <FormError message={errors.base}/>
      <ModalButtons
        saveCaption='time_tracking.shifts.Copy Shifts'
        saveEnabled={shifts.length > 0 && targetEmployees.length > 0}
        onSave={() => onCopy(targetEmployees.slice())}
        onCancel={onClose}
      />
    </Modal>
  );
});

export default withState(CopyEmployeeShiftsModal, CopyEmployeeShiftsModalState);
